/**
 * The external dependencies.
 */
import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
	display:flex;
	justify-content: space-between;
	align-items: center;
	color: #3b3b3b;
	font-size: 20px;
	line-height: 1;
	padding: 20px 0;
	border-bottom: 1px solid #e2e3e3;
`;

const Text = styled.span`
	${({big}) => big ? 'font-size: 40px;' : ''}
	${({medium}) => medium ? 'font-size: 25px;' : ''}
	${({bold}) => bold ? 'font-weight: 700;' : ''}
	${({blue}) => blue ? 'color: #43abf3;' : ''}
	${({wrapped}) => wrapped
    ? `
			background: #fff;
			padding: 8px 31px 10px;
			border-radius: 3px;
		`
    : ''
}
`;

const Header = ({
                    task,
                    quantity,
                    shortNumber,
                    workplace,
                    due,
                    step,
                    maxSteps,
					config,
                }) => (
    <Wrapper>
		<span>
			<Text big bold>{quantity}</Text> Stk.
		</span>

        {/*<Text wrapped blue bold medium>*/}
        {/*    {shortNumber}*/}
        {/*</Text>*/}

        {/*<span>*/}
        {/*	Arbeitsplatz  <Text blue>{workplace}</Text>*/}
        {/*</span>*/}

		{config.timea === step + "" && task.timea && <Text wrapped blue bold medium>
			Zeitvorgabe: {task.timea}h
		</Text>}

		{config.timeb === step + "" && task.timeb && <Text wrapped blue bold medium>
			Zeitvorgabe: {task.timeb}h
		</Text>}

        {config.timec === step + "" && task.timec && <Text wrapped blue bold medium>
			Zeitvorgabe: {task.timec}h
		</Text>}

        <span>
			Fällig bis <Text bold>{due}</Text>
		</span>

        <span>
			Fertigungsschritt <Text bold>{step}</Text> von {maxSteps}
		</span>
    </Wrapper>
);

export default Header;



// WEBPACK FOOTER //
// ./src/components/task/working/header.js